import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import type { User } from "@/types";
import { Card } from "@/components/ui/Card";
import { Input } from "@/components/ui/Input";
import { Button } from "@/components/ui/Button";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [recupero, setRecupero] = useState(false);
  const [avviso, setAvviso] = useState<string | null>(null);

  useEffect(() => { localStorage.removeItem("jwt"); }, []);

  // Il backend risponde sempre allo stesso modo (anti user-enumeration):
  // mostriamo il suo messaggio così com'è, senza confermare se l'email esiste.
  async function recuperaPassword() {
    if (!email.trim()) {
      setError("Inserisci la tua email, poi riprova");
      return;
    }
    setRecupero(true); setError(null); setAvviso(null);
    try {
      const r = await api.post<{ message: string }>("/auth/forgot-password", {
        email: email.trim(),
      });
      setAvviso(r.message);
    } catch (e: any) {
      setError(e.message ?? "Errore invio email");
    } finally {
      setRecupero(false);
    }
  }

  async function submit(ev: React.FormEvent) {
    ev.preventDefault();
    setSending(true); setError(null);
    try {
      const r = await api.post<{ token: string; user: User }>("/auth/admin/login", {
        email: email.trim(), password,
      });
      localStorage.setItem("jwt", r.token);
      nav("/admin/dashboard", { replace: true });
    } catch (e: any) {
      setError(e.message ?? "Errore login");
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <Card className="max-w-md w-full space-y-5">
        <header className="space-y-1">
          <div className="font-mono text-[14px] uppercase tracking-wider text-secondary">
            Area docente
          </div>
          <h1 className="text-[27px] font-serif text-primary">Login</h1>
        </header>

        <form onSubmit={submit} className="space-y-4">
          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
          <Input
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && (
            <div className="bg-red-500/10 border border-red-500/40 rounded-xl p-3 text-[16px] text-red-300">
              {error}
            </div>
          )}

          {avviso && (
            <div className="bg-accent/10 border border-accent/40 rounded-xl p-3 text-sm text-secondary">
              {avviso}
            </div>
          )}

          <Button type="submit" loading={sending} className="w-full">
            Entra
          </Button>

          <button
            type="button"
            onClick={recuperaPassword}
            disabled={recupero}
            className="w-full text-center text-xs font-mono text-secondary
                       hover:text-accent transition-colors disabled:opacity-50"
          >
            {recupero ? "Invio in corso…" : "Password dimenticata?"}
          </button>
        </form>
      </Card>
    </div>
  );
}
